/**
 * Класс для работы с заявками на главной странице
 * Флоу: телефон -> SMS код -> заполнение профиля (для новых) -> сохранение заявки
 * Попапы определены в popup-application.pug и подключаются через common_els.pug
 */
const Application = {
	// ID модуля авторизации
	authModuleId: 3,

	// ID модуля профиля
	profileModuleId: 4,

	// Текущий телефон
	currentPhone: '',

	// Таймер обратного отсчета
	countdownTimer: null,
	countdownValue: 60,

	/**
	 * Инициализация
	 */
	init: function() {
		// Маска для телефона в форме заявки
		this.initPhoneMask();

		// Инициализация полей ввода кода
		this.initCodeInputs();

		// Инициализация flatpickr для даты рождения
		this.initBirthdayPicker();
	},

	/**
	 * Маска для ввода телефона
	 */
	initPhoneMask: function() {
		const phoneInput = document.querySelector('.application-form__input[name="phone"]');
		if (!phoneInput) return;

		phoneInput.addEventListener('input', function(e) {
			let value = e.target.value.replace(/\D/g, '');

			if (value.length > 10) {
				value = value.slice(0, 10);
			}

			let formatted = '';
			if (value.length > 0) {
				formatted = '(' + value.substring(0, 3);
			}
			if (value.length > 3) {
				formatted += ') ' + value.substring(3, 6);
			}
			if (value.length > 6) {
				formatted += '-' + value.substring(6, 8);
			}
			if (value.length > 8) {
				formatted += '-' + value.substring(8, 10);
			}

			e.target.value = formatted;
		});
	},

	/**
	 * Инициализация полей ввода 4-значного кода
	 */
	initCodeInputs: function() {
		const container = document.getElementById('popup-application-code');
		if (!container) return;

		const inputs = container.querySelectorAll('.popup-application-code__input');
		const verifyBtn = document.getElementById('application-verify-btn');

		inputs.forEach((input, index) => {
			input.addEventListener('input', (e) => {
				const value = e.target.value.replace(/[^0-9]/g, '');
				e.target.value = value;

				if (value && index < inputs.length - 1) {
					inputs[index + 1].focus();
				}

				// Проверяем заполненность
				let allFilled = true;
				inputs.forEach(inp => {
					if (!inp.value) allFilled = false;
				});
				if (verifyBtn) verifyBtn.disabled = !allFilled;
			});

			input.addEventListener('keydown', (e) => {
				if (e.key === 'Backspace' && !e.target.value && index > 0) {
					inputs[index - 1].focus();
				}
			});

			input.addEventListener('paste', (e) => {
				e.preventDefault();
				const paste = (e.clipboardData || window.clipboardData).getData('text');
				const digits = paste.replace(/[^0-9]/g, '').split('');

				inputs.forEach((inp, i) => {
					if (digits[i]) inp.value = digits[i];
				});

				const lastFilled = Math.min(digits.length, inputs.length) - 1;
				if (lastFilled >= 0 && lastFilled < inputs.length - 1) {
					inputs[lastFilled + 1].focus();
				} else if (lastFilled >= 0) {
					inputs[lastFilled].focus();
				}

				let allFilled = true;
				inputs.forEach(inp => {
					if (!inp.value) allFilled = false;
				});
				if (verifyBtn) verifyBtn.disabled = !allFilled;
			});
		});
	},

	/**
	 * Инициализация flatpickr для даты рождения
	 */
	initBirthdayPicker: function() {
		const birthdayInput = document.getElementById('application-birthday');
		if (birthdayInput && window.flatpickr) {
			flatpickr(birthdayInput, {
				dateFormat: 'd.m.Y',
				maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
				defaultDate: new Date(new Date().setFullYear(new Date().getFullYear() - 30)),
				locale: { firstDayOfWeek: 1 }
			});
		}
	},

	/**
	 * Отправка формы заявки
	 */
	submit: function(form) {
		const phoneInput = form.querySelector('[name="phone"]');
		const errorEl = document.getElementById('application-form-error');
		const submitBtn = form.querySelector('[type="submit"]');

		if (errorEl) errorEl.textContent = '';

		// Получаем номер
		let phone = phoneInput.value.replace(/\D/g, '');
		if (phone.length === 10) {
			phone = '7' + phone;
		}

		// Валидация
		if (phone.length !== 11) {
			if (errorEl) errorEl.textContent = 'Введите корректный номер телефона';
			return;
		}

		this.currentPhone = phone;

		// Блокируем кнопку
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Отправка...';
		}

		// Отправляем SMS
		const formData = new FormData();
		formData.append('mid', this.authModuleId);
		formData.append('action', 'send_code');
		formData.append('phone', phone);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Отправить заявку';
			}

			if (data.success) {
				// Показываем попап ввода кода
				this.openCodePopup(phone);
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Ошибка отправки кода';
			}
		})
		.catch(error => {
			console.error('Application submit error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Отправить заявку';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Открытие попапа ввода кода
	 */
	openCodePopup: function(phone) {
		const popup = document.getElementById('popup-application-code');
		if (!popup) return;

		// Обновляем текст с номером телефона
		const phoneEl = document.getElementById('application-code-phone');
		if (phoneEl) {
			phoneEl.textContent = 'Код отправлен на номер ' + this.formatPhone(phone);
		}

		// Очищаем поля кода
		popup.querySelectorAll('.popup-application-code__input').forEach(input => {
			input.value = '';
		});

		// Очищаем ошибку
		const errorEl = document.getElementById('application-code-error');
		if (errorEl) errorEl.textContent = '';

		// Сбрасываем кнопку
		const verifyBtn = document.getElementById('application-verify-btn');
		if (verifyBtn) {
			verifyBtn.disabled = true;
			verifyBtn.textContent = 'Подтвердить';
		}

		// Показываем попап
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		// Фокус на первое поле
		setTimeout(() => {
			const firstInput = popup.querySelector('.popup-application-code__input');
			if (firstInput) firstInput.focus();
		}, 100);

		// Запускаем таймер
		this.startCountdown();
	},

	/**
	 * Закрытие попапа кода
	 */
	closeCodePopup: function() {
		const popup = document.getElementById('popup-application-code');
		if (popup) {
			popup.classList.remove('active');
		}
		document.body.style.overflow = '';
		this.stopCountdown();
	},

	/**
	 * Форматирование телефона
	 */
	formatPhone: function(phone) {
		const digits = phone.replace(/\D/g, '');
		if (digits.length === 11) {
			return '+' + digits[0] + ' (' + digits.slice(1, 4) + ') ' +
				digits.slice(4, 7) + '-' + digits.slice(7, 9) + '-' + digits.slice(9);
		}
		return '+' + phone;
	},

	/**
	 * Запуск таймера
	 */
	startCountdown: function() {
		this.stopCountdown();
		this.countdownValue = 60;

		const timer = document.getElementById('application-code-timer');
		const resend = document.getElementById('application-code-resend');
		const countdown = document.getElementById('application-code-countdown');

		if (timer) timer.style.display = '';
		if (resend) resend.style.display = 'none';

		this.countdownTimer = setInterval(() => {
			this.countdownValue--;
			if (countdown) countdown.textContent = this.countdownValue;

			if (this.countdownValue <= 0) {
				this.stopCountdown();
				if (timer) timer.style.display = 'none';
				if (resend) resend.style.display = '';
			}
		}, 1000);
	},

	/**
	 * Остановка таймера
	 */
	stopCountdown: function() {
		if (this.countdownTimer) {
			clearInterval(this.countdownTimer);
			this.countdownTimer = null;
		}
	},

	/**
	 * Повторная отправка кода
	 */
	resendCode: function() {
		const formData = new FormData();
		formData.append('mid', this.authModuleId);
		formData.append('action', 'send_code');
		formData.append('phone', this.currentPhone);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success) {
				// Очищаем поля
				document.querySelectorAll('.popup-application-code__input').forEach(input => {
					input.value = '';
				});
				document.querySelector('.popup-application-code__input')?.focus();
				this.startCountdown();
			} else {
				const errorEl = document.getElementById('application-code-error');
				if (errorEl) errorEl.textContent = data.error || 'Ошибка';
			}
		})
		.catch(error => {
			console.error('Resend error:', error);
		});
	},

	/**
	 * Проверка кода
	 */
	verifyCode: function() {
		const inputs = document.querySelectorAll('.popup-application-code__input');
		const errorEl = document.getElementById('application-code-error');
		const btn = document.getElementById('application-verify-btn');

		let code = '';
		inputs.forEach(input => code += input.value);

		if (code.length !== 4) {
			if (errorEl) errorEl.textContent = 'Введите 4-значный код';
			return;
		}

		if (errorEl) errorEl.textContent = '';
		if (btn) {
			btn.disabled = true;
			btn.textContent = 'Проверка...';
		}

		const formData = new FormData();
		formData.append('mid', this.authModuleId);
		formData.append('action', 'verify_code');
		formData.append('phone', this.currentPhone);
		formData.append('code', code);

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (btn) {
				btn.disabled = false;
				btn.textContent = 'Подтвердить';
			}

			if (data.success) {
				// Закрываем попап кода
				this.closeCodePopup();

				// Если новый пользователь - показываем попап заполнения профиля
				if (data.is_new) {
					this.openProfilePopup();
				} else {
					// Существующий пользователь - показываем успех
					this.showSuccess();
				}
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Неверный код';
			}
		})
		.catch(error => {
			console.error('Verify error:', error);
			if (btn) {
				btn.disabled = false;
				btn.textContent = 'Подтвердить';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Открыть попап заполнения профиля
	 */
	openProfilePopup: function() {
		const popup = document.getElementById('popup-application-profile');
		if (!popup) return;

		// Очищаем форму
		const form = document.getElementById('application-profile-form');
		if (form) form.reset();

		// Очищаем ошибку
		const errorEl = document.getElementById('application-profile-error');
		if (errorEl) errorEl.textContent = '';

		// Показываем попап
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		// Фокус на первое поле
		setTimeout(() => {
			const firstInput = popup.querySelector('input[name="str_lastname"]');
			if (firstInput) firstInput.focus();
		}, 100);
	},

	/**
	 * Закрытие попапа профиля
	 */
	closeProfilePopup: function() {
		const popup = document.getElementById('popup-application-profile');
		if (popup) {
			popup.classList.remove('active');
		}
		document.body.style.overflow = '';
	},

	/**
	 * Сохранение профиля из формы заявки
	 */
	saveProfile: function(form) {
		const errorEl = document.getElementById('application-profile-error');
		const submitBtn = form.querySelector('[type="submit"]');

		if (errorEl) errorEl.textContent = '';

		// Валидация возраста
		const birthdayInput = form.querySelector('[name="dte_birthday"]');
		if (birthdayInput && birthdayInput.value) {
			const parts = birthdayInput.value.split('.');
			if (parts.length === 3) {
				const birthday = new Date(parts[2], parts[1] - 1, parts[0]);
				const age = Math.floor((new Date() - birthday) / (365.25 * 24 * 60 * 60 * 1000));
				if (age < 18) {
					if (errorEl) errorEl.textContent = 'Вам должно быть не менее 18 лет';
					return;
				}
			}
		}

		const formData = new FormData(form);
		formData.append('mid', this.profileModuleId);
		formData.append('action', 'save');

		// Преобразуем дату в формат Y-m-d
		if (birthdayInput && birthdayInput.value) {
			const parts = birthdayInput.value.split('.');
			if (parts.length === 3) {
				formData.set('dte_birthday', parts[2] + '-' + parts[1] + '-' + parts[0]);
			}
		}

		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Сохранение...';
		}

		fetch('/ajax.php', {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Отправить заявку';
			}

			if (data.success) {
				this.closeProfilePopup();
				this.showSuccess();

				// Обновляем UI в хедере
				if (typeof Auth !== 'undefined') {
					Auth.onAuthSuccess({
						firstname: formData.get('str_firstname'),
						lastname: formData.get('str_lastname')
					});
				}
			} else {
				if (errorEl) errorEl.textContent = data.error || 'Ошибка сохранения';
			}
		})
		.catch(error => {
			console.error('Save profile error:', error);
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = 'Отправить заявку';
			}
			if (errorEl) errorEl.textContent = 'Ошибка соединения';
		});
	},

	/**
	 * Показать успешную отправку заявки
	 */
	showSuccess: function() {
		const popup = document.getElementById('popup-application-success');
		if (!popup) return;

		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		if (window.Lead) Lead.reachGoal('application_submit');

		if (window._tmr) window._tmr.push({ type: 'reachGoal', id: 3772358, goal: 'zayavka' });
	},

	/**
	 * Закрытие попапа успеха
	 */
	closeSuccessPopup: function() {
		const popup = document.getElementById('popup-application-success');
		if (popup) {
			popup.classList.remove('active');
		}
		document.body.style.overflow = '';
	}
};

// Автоинициализация
document.addEventListener('DOMContentLoaded', function() {
	Application.init();
});

// Экспорт
window.Application = Application;
